import { defineAgenda } from '@/shared/navigation/core';

/**
 * Agenda centrálního přehledu „Operace na pozadí". Klasická agenda otevíraná osamostatněně
 * (floating okno vpravo) přes OpsIndicator v horní liště; není v menu.
 */
export const jobsOverviewAgenda = defineAgenda({
  id: 'app.jobs.overview',
  path: 'app/jobs/overview',
  open: {},
  title: 'Operace na pozadí',
  icon: 'list',
  presentationHints: {
    shell: {
      layoutMode: 'overlay',
    },
  },
});
